import { render, staticRenderFns } from "./RDS.vue?vue&type=template&id=22ad1b92&scoped=true"
import script from "./RDS.vue?vue&type=script&lang=js"
export * from "./RDS.vue?vue&type=script&lang=js"
import style0 from "./RDS.vue?vue&type=style&index=0&id=22ad1b92&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22ad1b92",
  null
  
)

export default component.exports